import { render, staticRenderFns } from "./WirteOff.vue?vue&type=template&id=35442532&scoped=true&"
import script from "./WirteOff.vue?vue&type=script&lang=js&"
export * from "./WirteOff.vue?vue&type=script&lang=js&"
import style0 from "./WirteOff.vue?vue&type=style&index=0&lang=less&"
import style1 from "./WirteOff.vue?vue&type=style&index=1&id=35442532&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35442532",
  null
  
)

export default component.exports